import { render, staticRenderFns } from "./unionGoodsPriceEdit.vue?vue&type=template&id=377d0138&"
import script from "./unionGoodsPriceEdit.vue?vue&type=script&lang=js&"
export * from "./unionGoodsPriceEdit.vue?vue&type=script&lang=js&"
import style0 from "./unionGoodsPriceEdit.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "unionGoodsPriceEdit.vue"
export default component.exports